import { User } from "@xlabmedical/medic-api";
import { ButtonEnum, GlobalNavbarModel, useAppSettings } from "@xlabmedical/medic-web-framework";
import { GlobalConstants } from "@/constants/GlobalConstants";
import { usePatientsStore } from "@/stores/PatientsStore";

function isZimvieVendor(vendor?: string | null) {
    return vendor?.trim().toLowerCase() === "zimvie";
}

export async function GetNavbarModel(user: User, showDoctorsOnPatientList: boolean) {
    const { hasOpenTicket, hasRemoteSupport, loadAppSettings } = useAppSettings();
    const patientsStore = usePatientsStore();
    await loadAppSettings();
    const vendorName = (await patientsStore.ensureVendorName()) ?? GlobalConstants.VENDOR_NAME;

    const baseButtons = [
        ButtonEnum.USER_SETTINGS,
        ButtonEnum.PC_LIST,
        ButtonEnum.RG_WEB,
        ButtonEnum.HELP,
        hasOpenTicket.value && !isZimvieVendor(vendorName) && ButtonEnum.OPEN_TICKET,
        hasRemoteSupport.value && ButtonEnum.REMOTE_SUPPORT,
    ].filter(Boolean);

    return {
        buttons: baseButtons,
        showZimvieLogo: false,
        showNavbarPosition: true,
        username: user.username,
        isWizard: false,
        showDoctors: showDoctorsOnPatientList,
        isElearningEnabled: user.isElearningEnabled,
        elearningURL: user.elearningURL,
    } as unknown as GlobalNavbarModel;
}
